import {Model as BaseModel } from 'rawmodel';

export default class Model extends BaseModel {

}



// WEBPACK FOOTER //
// ./src/models/Model.ts